<template>
	<div class="erco-tooltip"
	     @mouseenter="handleMouseHover(true)"
	     @mouseleave="handleMouseHover(false)">
		<div class="pictogram_">
			<img v-if="invertIcon" src="~@/assets/img/tooltip-info.invers.svg"
			     class="_picto_image"
			     alt="i" />
			<img v-else src="~@/assets/img/tooltip-info.svg"
			     class="_picto_image"
			     alt="i" />
		</div>
		<div class="tooltip-box"
		     :class="{ visible: tooltipVisible }"
		     :style="tooltipBoxStyle"
		     ref="tooltipBox">
			<b-alert show :variant="variant">
				<span class="_title" v-if="title">{{ title }}:</span>
				<span class="_text">{{ text }}</span>
			</b-alert>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ErcoTooltipMolecules',

	data() {
		return {
			outerMargin: 15, // px
			tooltipBoxWidth: 420, // px
			currentlyHovering: false,
			addXOffset: 0,
		};
	},

	props: {
		variant: {
			type: String,
			required: false,
			default: '',
		},
		title: {
			type: String,
			required: false,
			default: '',
		},
		text: {
			type: String,
			required: true,
		},
		invertIcon: {
			type: Boolean,
			default: false,
		},
		offsetX: {
			type: String,
			default: '0',
		},
		offsetY: {
			type: String,
			default: '0',
		},
	},
	methods: {
		handleMouseHover(isHovering) {
			this.currentlyHovering = isHovering;
		},
	},
	computed: {
		tooltipVisible() {
			return this.currentlyHovering;
		},
		tooltipBoxStyle() {
			return {
				width: `${this.tooltipBoxWidth}px`,
				left: `${this.addXOffset}px`,
				marginTop: this.offsetY,
			};
		},
	},
	watch: {
		currentlyHovering(isHovering) {
			if (!isHovering) {
				return;
			}

			const tb = this.$refs.tooltipBox;

			tb.classList.add('hollow');
			tb.classList.add('visible');

			const totalOffsetLeft = tb.getBoundingClientRect().x - this.addXOffset;

			const offsetXDiff = document.body.offsetWidth - (totalOffsetLeft + this.tooltipBoxWidth);

			if (offsetXDiff < 0) {
				this.addXOffset = offsetXDiff + ((Math.sign(offsetXDiff) * this.outerMargin));
			} else {
				this.addXOffset = 0;
			}

			tb.classList.remove('visible');
			tb.classList.remove('hollow');
		},
	},
};
</script>

<style lang="scss">
	.erco-tooltip {
		position: relative;
		display: inline-block;
		text-align: left;
		white-space: normal;

		& > .pictogram_ {
			display: inline-block;

			& > ._picto_image {
				display: block;
				width: 0.7rem;
				height: 0.7rem;
			}
		}

		& > .tooltip-box {
			position: absolute;
			top: 1.5rem;
			left: 0;
			display: none;
			z-index: 1000;
			font-size: 1rem;
			line-height: 1.5;

			&.visible {
				display: block;

				&.show-above {
					top: -100%;
				}
			}

			&.hollow {
				opacity: 0;
			}

			& > .alert {
				box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
			}

			& ._title {
				font-weight: bold;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// ErcoTooltip.vue?7da61282